import classes from "./AccentTitle.module.scss";

const AccentTitle = props => {
  return ( 
    <div className={classes.AccentTitle + " " + props.customClass}>
      <span className={classes.Number}>{props.number}</span>
      <h3 className={classes.Title}>{props.title}</h3>
      {props.text ? <p className={classes.Text}>{props.text}</p> : ""}
    </div>
  )
}


export default AccentTitle;